<template>
  <div 
    v-if="visible"
    class="clipboard-notification visible"
    :data-url="url"
  >
    <div class="notification-card">
      <div class="notification-message">已复制到剪贴板</div>
      <div 
        class="action-button" 
        role="button" 
        tabindex="0"
        @click="handleView"
      >
        查看
      </div>
      <div class="close-wrapper">
        <div 
          class="close-trigger" 
          role="button" 
          aria-label="关闭" 
          tabindex="0"
          @click="handleClose"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" focusable="false">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { copyLinkBus } from '../utils/event-bus';

/**
 * ClipboardNotification - 复制成功通知组件
 * 
 * 功能：
 * - 显示“已复制到剪贴板”通知卡片
 * - 自动隐藏（3秒后）
 * - 提供“查看”按钮打开新窗口
 * - 提供“关闭”按钮手动隐藏
 * - 通过 EventBus 监听复制事件
 */
export default {
  name: 'ClipboardNotification',
  
  data() {
    return {
      visible: false,
      url: '',
      hideTimer: null
    };
  },
  
  mounted() {
    // 组件挂载时监听 EventBus 的 copy 事件
    copyLinkBus.on('copy', (url) => {
      this.showNotification(url);
    });
  },
  
  beforeUnmount() {
    // 组件销毁前清理定时器和事件监听
    this.clearHideTimer();
    copyLinkBus.off('copy', this.showNotification);
  },
  
  methods: {
    /**
     * 显示通知
     * @param {string} url - 复制的 URL
     */
    showNotification(url) {
      this.url = url;
      this.visible = true;
      this.startHideTimer();
    },
    
    /**
     * 启动自动隐藏定时器（3秒）
     */
    startHideTimer() {
      this.clearHideTimer();
      this.hideTimer = setTimeout(() => {
        this.visible = false;
      }, 3000);
    },
    
    /**
     * 清除自动隐藏定时器
     */
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    
    /**
     * 处理关闭操作
     */
    handleClose(e) {
      e.stopPropagation();
      this.visible = false;
    },
    
    /**
     * 处理查看操作
     */
    handleView(e) {
      e.stopPropagation();
      if (this.url) {
        window.open(this.url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
/* 样式由全局 CSS 管理，此处不需要 scoped styles */
/* 保持与原有 .clipboard-notification 类名兼容 */
</style>
